import React from 'react';
import { observer } from 'mobx-react';

// Helpers

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

const ExamDetailsCompleted = observer(class ExamDetailsCompleted extends React.Component {
  render() {
    const { translation } = this.props;
    const { exam } = this.props;
    const { courseData, userTimezone } = this.props.store.SessionStore;
    const { location } = exam.examSession;

    return (
      <section className="panel__section">
        <h2 className="panel__heading">{translation.heading}</h2>

        <ul className="data">
          {exam.examSession.schedulingModule !== 'vtc' &&
            <li>
              <strong className="subtitle">{translation.scheduled.date}</strong>
              {moment.utc(exam.examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
            </li>
          }
          {exam.examSession.schedulingModule === 'b-virtual' &&
            <li>
              <strong className="subtitle">{translation.scheduled.type}</strong>
              {translation.scheduled.b_virtual}
            </li>
          }
          {exam.examSession.schedulingModule === 'proctoru' &&
            <li>
              <strong className="subtitle">{translation.scheduled.type}</strong>
              {translation.scheduled.proctoru}
            </li>
          }
          {exam.examSession.schedulingModule === 'examity' &&
            <li>
              <strong className="subtitle">{translation.scheduled.type}</strong>
              {translation.scheduled.examity}
            </li>
          }
          {exam.examSession.schedulingModule === 'vtc' &&
            <li>
              <strong className="subtitle">{translation.scheduled.type}</strong>
              {translation.scheduled.vtc}
            </li>
          }
          {exam.examSession.schedulingModule === 'instructor-as-proctor' &&
            <li>
              <strong className="subtitle">{translation.scheduled.proctor}</strong>
              {courseData.instructor.firstName} {courseData.instructor.lastName} ({translation.scheduled.instructor})
            </li>
          }
          {
            exam.examSession.schedulingModule !== 'b-virtual' &&
            exam.examSession.schedulingModule !== 'proctoru' &&
            exam.examSession.schedulingModule !== 'examity' &&
            exam.examSession.schedulingModule !== 'vtc' &&
            location &&
            <li className="adr">
              <strong className="subtitle">{translation.scheduled.location}</strong>

              {/* {location.accountName &&
                <span className="fn org">{location.accountName}</span>
              } */}

              {(location.address1 || location.address2) &&
                <span className="street-address">
                  {location.address1}<br/>{location.address2 || ''}
                </span>
              }

              {location.place &&
                <span className="locality">{location.place}, </span>
              }

              {location.region &&
                <span className="region">{location.region} </span>
              }

              {location.postalCode &&
                <span className="postal-code">{location.postalCode}</span>
              }

              {location.country &&
                <span className="country">{location.country}</span>
              }
            </li>
          }
          {
            exam.examSession.schedulingModule !== 'b-virtual' &&
            exam.examSession.schedulingModule !== 'instructor-as-proctor' &&
            exam.examSession.schedulingModule !== 'vtc' &&
            exam.examSession.proctor &&
            <li>
              <strong className="subtitle">{translation.scheduled.proctor}</strong>
              {exam.examSession.proctor.firstName} {exam.examSession.proctor.lastName}
            </li>
          }
        </ul>
      </section>
    )
  }
})

export default translate('ExamDetailsCompleted')(ExamDetailsCompleted);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ExamDetailsCompleted.js